import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText';

export const EMAIL = 'email';
export const MIXPANEL_COHORT_ID = 'mixpanelCohortId';
export const FORM_FIELDS = {
  recepient: 'recepient',
  mixpanelCohortId: MIXPANEL_COHORT_ID,
  emal: EMAIL,
};

export const validationFields = {
  recepient: yup.string().required(REQUIRED),
  email: yup.string().when('recepient', {
    is: EMAIL,
    then: yup.string().required(REQUIRED),
  }),
  mixpanelCohortId: yup.string().when('recepient', {
    is: MIXPANEL_COHORT_ID,
    then: yup.string().required(REQUIRED),
  }),
  messageId: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = () => {
  return {
    recepient: '',
    email: '',
    mixpanelCohortId: '',
    messageId: '',
  };
};
